// extracted by mini-css-extract-plugin
module.exports = {"h2":"h2__3xi3j","form-submit-button":"form-submit-button__39r5b","button":"button__1TLOK","disabled":"disabled__387dz"};